import React from 'react';
import AnimatedSection from './AnimatedSection';
import SectionIntro from './SectionIntro';

const Vision: React.FC = () => {
  return (
    <section id="vision" className="section-pad relative">
      <div className="max-w-4xl mx-auto">
        <SectionIntro
          label="Our Vision"
          title={<>We&apos;re Building More Than Software.</>}
          className="mb-8"
        />

        <AnimatedSection animation="slide-up" delay={150}>
          <div className="space-y-6 text-lg md:text-xl text-muted leading-relaxed">
            <p>
              We believe retailers, commerce-driven brands, wine &amp; spirits businesses, hotels,
              lounges, cafés, and restaurants should not have to run on disconnected software,
              spreadsheets, and manual processes.
            </p>
            <p className="text-white">They need technology that works together.</p>
            <p>
              Our mission is to become Africa&apos;s leading technology company for AI-powered
              hospitality and commerce infrastructure — from inventory and accounting to storefronts,
              fulfilment, and business intelligence.
            </p>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default Vision;
